import { definePort, refusalPolicy } from '../../runtime/define-port';
import type { PanelGeneratedHttpPort } from '../runtime-port';
import type { NoticeInboxPort } from './contract-port';

/** 408/429/503 read as «unavailable». */
const NOTICE_INBOX_REFUSALS = refusalPolicy({ transientReason: 'unavailable' });

export function createNoticeInboxPort(http: Pick<PanelGeneratedHttpPort, 'read' | 'readConditional' | 'mutate'>): NoticeInboxPort {
  return definePort(http, (op): NoticeInboxPort => ({
    readInbox: async (command, entityTag = null) => {
      // Only a first page has a revision: an older page reads as it is.
      if (command.query?.beforeId !== undefined) return await op.read(command);
      const answer = await op.readConditional(command, entityTag);
      if (answer.kind !== 'success') return answer;
      return answer.canonical.kind === 'not_modified' ? { kind: 'not_modified' }
        : { kind: 'success', canonical: answer.canonical.value, entityTag: answer.canonical.entityTag };
    },
    seen: op.mutate,
    read: op.mutate,
    dismiss: op.mutate,
  }), NOTICE_INBOX_REFUSALS);
}
